module.exports = __webpack_public_path__ + "img/partydynamic3.81af9ea7.png";